import { fetchIStatus } from '@/shared/fetchIStatus';

export const removeHouseholdAccess = async () => {
    return await fetchIStatus('/api/patients/remove-household-access', 'post');
};
